import styled from 'styled-components';

export const ContainerAssociados = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  background-color: #fff;
  border: 1px solid #dee2e6;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
`;

export const ContainerResumo = styled.div`
  min-width: 270px;
  max-width: 300px;

  /* & + div {
    margin-left: 20px;
  } */

  > h5 {
    text-align: center;
    font-size: 1rem;
    margin-bottom: 5px;
  }
`;

export const RelatorioHeader = styled.div`
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-bottom-width: 0;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  padding: 0.75rem 1.25rem;
  font-weight: bold;
  text-align: center;
`;
